import { useEffect } from "react"

export const fn = function (event) {
  event.returnValue = ""
}

const useBeforeUnload = () => {
  useEffect(() => {
    window.addEventListener("beforeunload", fn)

    return () => {
      window.removeEventListener("beforeunload", fn)
    }
  }, [])
}

export default useBeforeUnload
